module.exports = __webpack_public_path__ + "static/Poppins-Extralight-86a2f13e91ac85080ebaeaab9463b9f1.ttf";